import { Component, inject, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { RecordActionTypes } from 'projects/deusto-extension/src/lib/store/actions/record-actions';
import { UdeuBoud } from 'projects/deusto-extension/src/lib/model/classes/udeu-boud';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UdeuRecord } from 'projects/deusto-extension/src/lib/model/classes/udeu-record';
import { RecordService } from 'projects/deusto-extension/src/lib/services/record.service';

@Component({
  selector: 'alden-publication-info',
  templateUrl: './publication-info.component.html',
  styleUrls: ['./publication-info.component.scss'],
})
export class PublicationInfoComponent implements OnInit {
  @Input() boud: UdeuBoud;
  @Input() isManager: boolean;
  
  private _formBuilder = inject(FormBuilder);
  formGroup: FormGroup<any>;

  record: UdeuRecord;

  constructor(public dialog: MatDialog, private recordService: RecordService) { }

  ngOnInit(): void {
    this.record = this.boud.info.record as UdeuRecord;
    this.formGroup = this._formBuilder.group({
      publicationDate: [{ value: this.boud.info.publicationDate, disabled: true }],
      publicationUser: [{ value: this.boud.info.publicationUser, disabled: true }],
      recordId: [{ value: this.record?.id, disabled: true }],
      recordName: [{ value: this.record?.name, disabled: true }],
      recordScopeContent: [{ value: this.record?.info?.scopeContent, disabled: true }]
    });
  }

  viewReg(id: string) {
    this.recordService.openRecordDialogComponent([id], RecordActionTypes.ViewRecord, false, 5);
  }

}
